module.exports = __webpack_public_path__ + "img/key_hover1.4b390a97.png";